/* eslint-disable no-unused-vars */
import React, {useState} from 'react';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {ErrorMessage} from '@hookform/error-message';
import {Form} from 'react-bootstrap';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import './styles.css';
import {Toast} from './SweetAlert';
import TokenManager from './TokenManager';


/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Login Page.
  */
function Login() {
  const {handleSubmit, register, formState: {errors}} = useForm();
  const [message, setMessage] = useState({data: '', type: ''});
  const navigate = useNavigate();

  const onSubmit = (data) => {
    Toast.fire({
      icon: 'loading',
      title: 'Login in progress...',
    });
    axios.post(`https://blooming-springs-86289.herokuapp.com/api/login`, {
      email: data.email,
      password: data.password,
    }, {
      withCredentials: true,
    })
        .then((response) => {
          Toast.fire({
            icon: 'success',
            title: 'Success!',
          });
          const {token, memberId} = response.data;
          TokenManager.setItems(token, memberId);

          navigate('home');
        })
        .catch((err) => {
          if (typeof (err.response) != 'undefined') {
            Toast.fire({
              icon: 'error',
              title: 'Error!',
            });
            if (err.response.request.status === 401) {
              Toast.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Login credential is not valid. Please try again.',
              });
            } else {
              Toast.fire({
                icon: 'error',
                title: 'Error!',
                text: 'You are unable to login. Please try again later.',
              });
            }
          } else {
            Toast.fire({
              icon: 'error',
              title: 'Error!',
              text: 'This is a system error.Please try again later.',
            });
          }
        });
    // .finally(() => setloading(false))
  };
  return (
    <div className="background">
      <h2 className='header'>Burger Lab</h2>
      <Form className="login-form" noValidate onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            'mx': 'auto',
            'width': 400,
            'display': 'flex',
            'flexDirection': 'column',
            '& .MuiTextField-root': {width: '46ch'},
          }}>
          <div id="title">Welcome Back!</div>
          <div id="email">
            <TextField type="email" label={'Email'} id="margin-none"
              {...register('email', {required: 'Email is required'})} />
            <ErrorMessage
              errors={errors}
              name="email"
              render={({message}) => <div id="message">{message}</div>} />
          </div>
          <div id="password">
            <TextField type="password" label={'Password'}
              id="margin-none"
              {...register('password', {required: 'Password is required'})} />
            <ErrorMessage
              errors={errors}
              name="password"
              render={({message}) => <div id="message">{message}</div>} />
          </div>
          <Button variant="contained" type="submit" id="login">Login</Button>
          <div id="or">OR</div>
          <Button variant="contained" id="signup"
            onClick={() => navigate('/register')} >Sign Up</Button>
        </Box>
      </Form>
    </div>
  );
}

export default Login;
